import React from 'react';
import './App.css';

function App() {
  const handleEmailClick = () => {
    const email = 'info@nexapromos.com';
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
      <div className="max-w-2xl w-full mx-auto">
        <div className="bg-white shadow-xl rounded-2xl p-8 md:p-12 border border-gray-100">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-8 text-center tracking-tight">
            Contact Us
          </h1>
          
          <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed text-center">
            <p className="text-lg">
              If you have questions about our policies, terms, or compliance practices, you may contact us at:
            </p>

            <div className="bg-gray-50 rounded-xl p-6 space-y-4 border border-gray-200 inline-block w-full">
              <div className="flex flex-col space-y-2">
                <span className="text-sm uppercase tracking-wider text-gray-500 font-semibold">Email</span>
                <button style={{
      color: 'rgb(37, 99, 235)'
    }}
                  onClick={handleEmailClick}
                  className="text-xl text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200"
                >info [at] nexapromos [dot] com</button>
              </div>
              
              <div className="pt-4 border-t border-gray-200 flex flex-col space-y-2">
                <span className="text-sm uppercase tracking-wider text-gray-500 font-semibold">Company</span>
                <span className="text-xl text-gray-900 font-medium">
                  Nexa Nova Media LLC
                </span>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-100">
              <p className="text-sm text-gray-400">
                This page was last updated on January 24, 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;